export const isFontAwesomeIcon = (iconSrc?: unknown): boolean => {
  if (typeof iconSrc !== 'string') return false;

  return iconSrc.startsWith('fa-') || iconSrc.includes(' fa-');
};
